const stopLossMessages = {
  titleAndSubtitle: {
    title: 'Stoploss Triggers',
    subTitle:
      'List prescribed by the Self Insurance Institute of America (SIIA), which identifies conditions commonly leading to eventual stoploss claims',
  },
  buttonText: {
    download: 'Download',
    queryData: 'Query Data',
  },
  cardText: {
    totalEligible: 'Total Eligible',
    employees: 'Employees',
    totalEnrolled: 'Total Enrolled',
    dependents: 'Dependents',
    totalCost: 'Cohort Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'Cohort PMPM',
    pepm: 'Cohort PEPM',
    members: 'Cohort Members',
  },
  toggleLables: {
    cardView: 'Card View',
    tableView: 'Table View',
  },
  viewsHeading: {
    diseases: 'Diseases',
  },
  SUMMARY_FOR: 'Summary for ',
  report: {
    title: 'Stop Loss Aggregate Report',
    subTitle: 'Stop Loss Summary and Aggregate Report',
    currentYear: 'CURRENT PLAN YEAR',
    lineChartTitle: 'Paid Claims Subject to Aggregate',
    lineChartSubTitle:
      'Comparison of paid claims subject to aggregate against the aggregate attachment point',
    aggregateReportTitle: 'Aggregate Report',
    aggreateReportSubTitle:
      'A policy provision capping the total amount of claims an insurer will reimburse over a defined period,',
  },
};

export default stopLossMessages;
